import ApiService, { HTTPMethod } from "./api.core";
import { Transformer } from "../models/Transformer";
import UserProfileModel from "../models/user-models/UserProfileModel";
import State from "../models/user-models/State";
import dayjs from "dayjs";
import Resizer from "../utilities/Resizer";
import { dataImageToFile, removeDuplicateAdditionalInsured } from '../services/utils'
import CreditCardModel from '../models/user-models/CreditCardModal'
import { AdditionalInsuredModel } from '../models/user-models/AdditionalInsuredModel'
import { FirebaseService, FirebaseConfigKey } from "../services/FirebaseService";
import DataLayerService from "../services/DataLayerService";

export class ModificationApi {  
  static async getModifyAmount(id, isSubscription= false, body) {
    if(id!=""){
        let response = await ApiService.fetch(`modify/getModifyAmount/${id}`, HTTPMethod.POST,body);
    return response
    }
  }

  static async getMidtermAmount(id, isSubscription= false, body) {
    if(id!=""){
        let response = await ApiService.fetch(`modify/insurance/${id}/midtermAmount`, HTTPMethod.POST,body);
    return response
    }
  }

  static async modify(id, body) {
    let response = await ApiService.fetch(`modify/${id}`, HTTPMethod.POST,body);
    return response
  }

  static async midterm(id, body) {
    let response = await ApiService.fetch(`modify/insurance/${id}/midterm`, HTTPMethod.POST,body);
    return response
  }

  static async loadLiabilityOptions(insuranceId) {
    let response = await ApiService.fetch(`modify/liabilityOptions/${insuranceId}`, HTTPMethod.GET);
    return response
  }

  static async getCancelAmount(insuranceId, cancelDate, isFullRefund,isNotRefundReq){
      let url = decodeURI(`modify/insurance/${insuranceId}/cancelAmount?FullRefund=${isFullRefund}&CancelDate=${cancelDate.toISOString()}&isNotRefundRequest=${isNotRefundReq}`)
      let response = await ApiService.fetch(url, HTTPMethod.GET);
      return response
  }

  static async lossPayeeRequest(drones,equipments, additionalInsured, insuranceId){
    let response = await ApiService.fetch(`modify/insurance/lossPayeeEndorsement/${insuranceId}`, HTTPMethod.POST,{
          "additional_insured_id": additionalInsured,
          "drones_ids": drones,
          "equipments_ids":equipments
      });
      return response
  }

  static async cancelPolicy(insuranceId, cancelDate, isFullRefund, comment, reason,isNotRefundReq){
      let response = await ApiService.fetch(`modify/insurance/${insuranceId}/cancel`, HTTPMethod.POST,{
          "cancel_date": cancelDate,
          "full_refund": isFullRefund,
          "comment": comment,
          "reason": reason,
          "is_not_refund_request":isNotRefundReq
      });
      return response
  }

  static async modifyAdditionalInsured(insuranceId, body) {
      let res = await ApiService.fetch(`modify/insurance/additionalInsured/${insuranceId}`, HTTPMethod.PUT,body);
      if(res.ok){
        res.parsedData = {
          insurance: Transformer.parseActiveInsuranceModel(res.data)
        }
      }

      return res
  }
}
